import React from 'react';
import { string } from 'prop-types';
import { useHelmet, TitleTag, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';

const metadataHandler = ({ props }) => {
  return [
    new TitleTag(props.title),
    new MetaTag({ name: 'description', content: props.description, id: 'description' }),
    new LinkTag({ rel: 'canonical', href: props.canonical, id: 'canonical' })
  ];
};

const PrivacyMetadata = (props) => {

  const { title, description, canonical } = props;

  useHelmet('privacyMetadata', { props }, metadataHandler, [title, description, canonical]);
  return null;
};

PrivacyMetadata.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  canonical: string.isRequired
};

export { PrivacyMetadata };

PrivacyMetadata.propTypes = {
  title: string,
  description: string,
  canonical: string
};

PrivacyMetadata.defaultProps = {
  title: '',
  description: '',
  canonical: ''
};
